module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-dialog-modal', {
    ref: "itemsMoveModal",
    attrs: {
      "title": _vm.$t('seller.moveItemsTitle')
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('common.warning')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "seller.moveItemsWarning",
      "tag": "p"
    }
  }, [_c('strong', {
    attrs: {
      "place": "unsoldItems"
    }
  }, [_vm._v(_vm._s(_vm.$t('seller.moveItemsUnsoldItems')))])])], 1), _vm._v("\n\n                " + _vm._s(_vm.$t('seller.moveItemsQuestionAuction')) + "\n\n                "), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.options
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "block": ""
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("\n\n\t\t\t\t\t" + _vm._s(_vm.$t('common.cancel')) + "\n\n\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "disabled": _vm.isMoving,
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_c('loader-spinner', {
    attrs: {
      "text": _vm.$t('seller.moveItemsAction'),
      "show-spinner": _vm.isMoving
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0969103a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Seller/ItemsMoveModal.vue
// module id = 1276
// module chunks = 1